<template>
  <a
    href="#"
    class="social-btn skip-btn"
    :style="loginButtonStyles"
    :class="{ disabled: isProcessing }"
    @click.prevent="handleClick"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-wifi" />
    <span v-text="$t('freewifi')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'
  export default {
    name: 'SkipLogin',
    props: ['api', 'action', 'wftkn'],
    data() {
      return {
        isProcessing: false,
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || '#7f017f',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.layouts.appLayout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.freeWifiBtn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
    },
    methods: {
      async handleClick() {
        logUserAction({ type: 'click', label: 'Skip Login Button' })
        if (this.isProcessing || this.api.includes('preview')) return

        this.isProcessing = true
        this.$eventHub.$emit('showGlobalLoader')
        try {
          const url = `${this.api}&action=${this.action}&wftkn=${this.wftkn}`
          window.location.href = url
        } catch (error) {
          this.isProcessing = false
          this.$eventHub.$emit('hideGlobalLoader')
        }
      },
    },
  }
</script>

<style>
  .skip-btn {
    background: #7f017f;
  }
  .skip-btn:hover {
    background: #690169;
  }
  .skip-btn.disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
</style>
